import { Sparkles, ScanSearch, Send, MessagesSquare, Trophy, UserCheck } from "lucide-react";

const items = [
  {
    icon: ScanSearch,
    title: "Structured screening",
    desc: "We assess your skills, projects, and goals upfront - only candidates we genuinely believe in get onboarded.",
    tid: "service-screening",
  },
  {
    icon: Sparkles,
    title: "Profile polishing",
    desc: "Resume, LinkedIn, and portfolio refined to match the bar of the roles you actually want.",
    tid: "service-polish",
  },
  {
    icon: Send,
    title: "Direct outreach",
    desc: "Hand-picked introductions to the right HRs, CTOs, and CEOs - no portals, no black holes.",
    tid: "service-outreach",
  },
  {
    icon: Trophy,
    title: "Right-fit placement",
    desc: "The match that fits - your stack, your salary band, your career trajectory.",
    tid: "service-placement",
  },
  {
    icon: MessagesSquare,
    title: "Direct interview handoff",
    desc: "Once introduced, the HR reaches out to you directly to schedule. No middleman, no back-and-forth.",
    tid: "service-handoff",
  },
  {
    icon: UserCheck,
    title: "Dedicated success mentor",
    desc: "One mentor with you from screening to signing. No handoffs, no drop-offs.",
    tid: "service-mentor",
  },
];

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="bg-[#F0EFEB] py-24 sm:py-32 border-y border-[#1C1C1A]/10">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="grid grid-cols-12 gap-y-10 gap-x-8 items-end mb-14">
          <div className="col-span-12 md:col-span-7">
            <p className="label-eyebrow text-[#143628] mb-5">What we do</p>
            <h2 className="font-serif-display text-4xl sm:text-5xl leading-[1.05] tracking-tight">
              The full placement stack -{" "}
              <em className="italic text-[#143628]">handled.</em>
            </h2>
          </div>
          <p className="col-span-12 md:col-span-5 text-[#4A4A48] text-lg leading-relaxed">
            From the first conversation to the day you sign, every step is run by a
            placement specialist. No automated drip campaigns.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#1C1C1A]/10">
          {items.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                data-testid={s.tid}
                className="bg-[#F9F9F7] p-8 hover:bg-white transition-colors group"
              >
                <Icon className="h-6 w-6 text-[#143628] mb-6" />
                <h3 className="font-serif-display text-2xl leading-tight mb-3">{s.title}</h3>
                <p className="text-[#4A4A48] text-[15px] leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
